import { Button, Label, useUrlParams } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useVerifyEmailMutation } from '../../api/queries/auth';
import { AuthLayout } from '../../components';
import { Path } from '../../enums';

const VerifyEmail: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [queryParams] = useUrlParams();

    const verifyEmailMutation = useVerifyEmailMutation();

    React.useEffect(() => {
        const code = queryParams.get('code');

        if (code) {
            verifyEmailMutation.mutate(code);
        } else {
            navigate(Path.LOGIN);
        }
    }, []);

    const getMessage = () => {
        if (verifyEmailMutation.isError) {
            return <Label type="text" value={t('verifyEmail.error')} error={true} />;
        } else if (verifyEmailMutation.isSuccess) {
            return <p className="auth-layout__text">{t('verifyEmail.confirmation')}</p>;
        } else {
            return <></>;
        }
    };

    const handleClick = () => {
        navigate(Path.LOGIN);
    };

    return (
        <AuthLayout name="verify-email" title={t('verifyEmail.title')} isLoading={verifyEmailMutation.isLoading}>
            {getMessage()}
            <Button label={t('verifyEmail.buttons.login')} onClick={handleClick} />
        </AuthLayout>
    );
};

export default VerifyEmail;
